/* eslint-disable no-param-reassign,no-underscore-dangle,@typescript-eslint/no-unused-vars */
import * as moment from 'moment';

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerGoogleAnalytics4SourceComponent', [
    '$rootScope',
    'DesignerBaseSourceAndDestinationComponent',
    'DesignerSchema',

    function ($rootScope, DesignerBaseSourceAndDestinationComponent, DesignerSchema) {
      function DesignerGoogleAnalytics4SourceComponent() {
        this.cloud_storage_connection_id = null;

        this.property_ids = null;
        this.account_name_field_alias = null;
        this.property_name_field_alias = null;
        this.property_id_field_alias = null;
        this.account_id_field_alias = null;

        this.report_date_range_type = null;
        this.report_date_range_min = null;
        this.report_date_range_max = null;

        this.api_version = null;
        this.custom_fields = null;

        this.report_sampling_level = null;

        this.availableFields = [];

        this.metrics = [];
        this.dimensions = [];
        this.quota_user = null;

        DesignerBaseSourceAndDestinationComponent.apply(this);
      }

      DesignerGoogleAnalytics4SourceComponent.prototype = new DesignerBaseSourceAndDestinationComponent();

      const dataRangeOptions = [
        {
          min: 'today',
          max: 'today',
          value: 'TODAY',
        },
        {
          min: 'yesterday',
          max: 'yesterday',
          value: 'YESTERDAY',
        },
        {
          min: '3daysAgo',
          max: 'today',
          value: 'LAST_3_DAYS',
        },
        {
          min: '7daysAgo',
          max: 'today',
          value: 'LAST_7_DAYS',
        },
        {
          min: '14daysAgo',
          max: 'today',
          value: 'LAST_14_DAYS',
        },
        {
          min: '30daysAgo',
          max: 'today',
          value: 'LAST_30_DAYS',
        },
        {
          min: '2005-01-01',
          max: 'today',
          value: 'ALL_TIME',
        },
        {
          min: '',
          max: '',
          value: 'CUSTOM_DATE',
        },
      ];

      DesignerGoogleAnalytics4SourceComponent.prototype.getData = function () {
        const data = DesignerBaseSourceAndDestinationComponent.prototype.getData.call(this);

        _.extend(data, {
          cloud_storage_connection_id: String(this.connection.id || ''),
          property_ids: this.property_ids || this.defaults.property_ids,

          account_name_field_alias: this.account_name_field_alias || this.defaults.account_name_field_alias,
          property_name_field_alias: this.property_name_field_alias || this.defaults.property_name_field_alias,
          property_id_field_alias: this.property_id_field_alias || this.defaults.property_id_field_alias,
          account_id_field_alias: this.account_id_field_alias || this.defaults.account_id_field_alias,
          report_on: this.report_on || this.defaults.report_on,
          api_version: this.api_version || this.defaults.api_version,
          custom_fields: this.custom_fields || this.defaults.custom_fields,

          report_sampling_level: this.report_sampling_level || this.defaults.report_sampling_level,

          report_date_range_min: this.report_date_range_min || this.defaults.report_date_range_min,
          report_date_range_max: this.report_date_range_max || this.defaults.report_date_range_max,

          metrics: this.metrics,
          dimensions: this.dimensions,
          quota_user: this.quota_user,
        });

        return data;
      };

      DesignerGoogleAnalytics4SourceComponent.prototype.setFormData = function (data) {
        // server can only get range type as custom type
        if (data.report_date_range_type !== 'CUSTOM_DATE') {
          const dateRange = _.find(dataRangeOptions, { value: data.report_date_range_type });
          if (dateRange) {
            data.report_date_range_type = 'CUSTOM_DATE';
            data.report_date_range_min = dateRange.min;
            data.report_date_range_max = dateRange.max;
          }
        }

        const accountNameIndex = _.findIndex(data.schema.fields, { name: 'account_name' });

        if (accountNameIndex > -1) {
          data.account_name_field_alias = data.schema.fields[accountNameIndex].alias;
          data.schema.fields.splice(accountNameIndex, 1);
        }

        const propertyNameIndex = _.findIndex(data.schema.fields, { name: 'property_name' });

        if (propertyNameIndex > -1) {
          data.property_name_field_alias = data.schema.fields[propertyNameIndex].alias;
          data.schema.fields.splice(propertyNameIndex, 1);
        }

        const propertyIdIndex = _.findIndex(data.schema.fields, { name: 'property_id' });

        if (propertyIdIndex > -1) {
          data.property_id_field_alias = data.schema.fields[propertyIdIndex].alias;
          data.schema.fields.splice(propertyIdIndex, 1);
        }

        const accountIdIndex = _.findIndex(data.schema.fields, { name: 'account_id' });

        if (accountIdIndex > -1) {
          data.account_id_field_alias = data.schema.fields[accountIdIndex].alias;
          data.schema.fields.splice(accountIdIndex, 1);
        }

        this.setData(data);

        DesignerBaseSourceAndDestinationComponent.prototype.setFormData.call(this, data);
      };

      DesignerGoogleAnalytics4SourceComponent.prototype.setData = function (data) {
        this.cloud_storage_connection_id = String(this.connection.id || '');
        this.property_ids = data.property_ids;
        this.report_date_range_type = data.report_date_range_type;
        const dateRangeMin = moment(new Date(data.report_date_range_min)).format('YYYY-MM-DD');
        this.report_date_range_min = dateRangeMin === 'Invalid date' ? data.report_date_range_min : dateRangeMin;
        const dateRangeMax = moment(new Date(data.report_date_range_max)).format('YYYY-MM-DD');
        this.report_date_range_max = dateRangeMax === 'Invalid date' ? data.report_date_range_max : dateRangeMax;
        this.account_name_field_alias = data.account_name_field_alias;
        this.property_name_field_alias = data.property_name_field_alias;
        this.property_id_field_alias = data.property_id_field_alias;
        this.account_id_field_alias = data.account_id_field_alias;
        this.quota_user = data.quota_user;
        this.api_version = data.api_version;
        this.custom_fields = data.custom_fields;

        this.report_sampling_level = data.report_sampling_level;

        this.metrics = data.metrics;
        this.dimensions = data.dimensions;

        this.report_on = data.report_on;
        if (!this.report_on) {
          if (!this.property_ids) this.report_on = 'all';
          else if (this.property_ids.charAt(0) === '$') this.report_on = 'custom';
          else this.report_on = 'specific';
        }

        if (this.report_on === 'all') {
          this.property_ids = '';
        }

        DesignerBaseSourceAndDestinationComponent.prototype.setData.call(this, data);
      };

      DesignerGoogleAnalytics4SourceComponent.prototype.getSchema = function () {
        const schema = new DesignerSchema();
        const _this = this;

        schema.id = this.id;
        schema.name = this.name;

        const getFieldAlias = function (fieldName) {
          return _.find(_this.schema.fields, { name: fieldName }).alias;
        };

        schema.fields.push({
          name: this.account_id_field_alias,
        });

        schema.fields.push({
          name: this.account_name_field_alias,
        });

        schema.fields.push({
          name: this.property_name_field_alias,
        });

        schema.fields.push({
          name: this.property_id_field_alias,
        });

        _.each(this.dimensions, function (dimension) {
          schema.fields.push({
            name: getFieldAlias(dimension),
          });
        });

        _.each(this.metrics, function (metric) {
          schema.fields.push({
            name: getFieldAlias(metric),
          });
        });

        return schema;
      };

      return DesignerGoogleAnalytics4SourceComponent;
    },
  ]);
})(window.angular);
